export default __webpack_public_path__ + "static/media/secondary.f90704eb73ce117fcb013b7c33fa2aaa.svg";